import React from 'react'
import { Router, RouteComponentProps } from '@reach/router'
import Appbar from 'components/Appbar'
import WorkplaceGroupSearch from './Search'
import TableView from './TableView'
import useWorkplaceGroups from './hooks/useWorkplaceGroups'
import { ModalLayer, PageContent } from '@ui'

export default function WorkplaceGroupManagement({ navigate }: RouteComponentProps) {
  const workplaceGroups = useWorkplaceGroups()

  return (
    <>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <Router primary={false} navigate={navigate}>
        <ModalLayer path="*" />
      </Router>
      <Appbar title="Workplace groups">
        <WorkplaceGroupSearch
          navigate={navigate}
          queryTable={(query) => {
            workplaceGroups.applyQuery(query)
          }}
        />
      </Appbar>
      <PageContent>
        <TableView
          {...{
            workplaceGroups,
            navigate,
          }}
        />
      </PageContent>
    </>
  )
}
